class GetRainfallByIntervalUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(START,END) {
    const resp= await this.repository.getRainfallByInterval(START,END)
    return resp
  }
}
export {
  GetRainfallByIntervalUseCase,
};
